export var LoadedState;
(function (LoadedState) {
    LoadedState["LOADING"] = "LOADING";
    LoadedState["LOADED"] = "LOADED";
    LoadedState["NOT_LOADED"] = "NOT_LOADED";
    LoadedState["FAILED_TO_LOAD_IN_BROWSER"] = "FAILED_TO_LOAD_IN_BROWSER";
})(LoadedState || (LoadedState = {}));
export var ReadyState;
(function (ReadyState) {
    ReadyState["READY"] = "READY";
    ReadyState["NOT_READY"] = "NOT_READY";
})(ReadyState || (ReadyState = {}));
//# sourceMappingURL=shared.types.js.map